const responseTypeDocumentStarAssignment = {

    "payload": [
        {
            "assignTypeId": 45,
            "assignTypeName": "Individual",
    
        },
        {
            "assignTypeId": 46,
            "assignTypeName": "Todos",

        },
        {
            "assignTypeId": 47,
            "assignTypeName": "Plantilla",

        },
    ]
};

const responseTypeStar = {

    "payload": [
        {
            "id": "1",
            "name": "Beneficio",

        },
        {
            "id": "2",
            "name": "Sodexo",

        },
    ]
};

const responseCategoryStarAssignment = {

    "payload": {
        "affiliateCount": 5,
        "listRecognitionCategoryParameters": [
        {
            "recognitionCategoryId": 1,
            "categoryName": "Blue",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/blueStar.svg",
            "shapeCount": 6,
            "maxRecognitionCount":6
        },
        {
            "recognitionCategoryId": 2,
            "categoryName": "Green",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/greenStar.svg",
            "shapeCount": 1,
            "maxRecognitionCount":1
        },
        {
            "recognitionCategoryId": 3,
            "categoryName": "Gold",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/goldStar.svg",
            "shapeCount": 5,
            "maxRecognitionCount":5
        },
        {
            "recognitionCategoryId": 4,
            "categoryName": "Black",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/blackStar.svg",
            "shapeCount": 5,
            "maxRecognitionCount":5
        }
      ]
    }
};

const responseCreate = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Asignado exitosamente'
        }
    }
};

const downloadTemplate = {
    status: 200,
    data: {
        "payload": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/blueStar.svg"
    }
};

const responseCads = {
    "payload": [
        {
            "recognitionCategoryId": 1,
            "categoryName": "Blue",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/blueStar.svg",
            "shapeCount": 6
        },
        {
            "recognitionCategoryId": 2,
            "categoryName": "Green",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/greenStar.svg",
            "shapeCount": 1
        },
        {
            "recognitionCategoryId": 3,
            "categoryName": "Gold",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/goldStar.svg",
            "shapeCount": 5
        },
        {
            "recognitionCategoryId": 4,
            "categoryName": "Black",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/recognition_categories/blackStar.svg",
            "shapeCount": 5
        }
    ]
};

const listTemplate = {
    payload: {
      reports: [
        {
            monetizationReportId: 23,
            startDate: "2025-02-22",
            requestCount: 16,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/23_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        },
        {
            monetizationReportId: 24,
            startDate: "2025-02-25",
            requestCount: 16,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/24_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        },
        {
            monetizationReportId: 25,
            startDate: "2025-02-26",
            requestCount: 16,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/25_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        },
        {
            monetizationReportId: 26,
            startDate: "2025-02-27",
            requestCount: 21,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/26_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        },
        {
            monetizationReportId: 27,
            startDate: "2025-02-27",
            requestCount: 21,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/27_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        },
        {
            monetizationReportId: 28,
            startDate: "2025-02-27",
            requestCount: 21,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/28_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        },
        {
            monetizationReportId: 29,
            startDate: "2025-02-27",
            requestCount: 21,
            fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/29_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
            requestStatus: "Pendiente"
        }
      ],
      totalRequest: 7
    }
};

const scatterStarsTemplates = {
    payload: {
        message: "Confirmación de dispercion exitoso",
    },
};

const responseTypeStarList = {
    "payload": [
        {
            "starId": "1",
            "iconPath": "https://ibliss-icons-dev.s3.amazonaws.com/label/starOutlined.svg",
            "nameStar": "Value"
        },
        {
            "starId": "2",
            "iconPath": "https://ibliss-icons-dev.s3.amazonaws.com/label/watch.svg",
            "nameStar": "Zen"
        }
    ]
};

const responseListRequestsZen = {
    payload: [
       {
            "requestId": 1,
            "applicantsName": "Jefferson Izquierdo",
            "approverName": "Ibliss Coré perez",
            "requestHours": 2,
            "requestDate": "2025-12-24T15:44:56"
        },
        {
            "requestId": 2,
            "applicantsName": "Shaden Acevedo",
            "approverName": "Ibliss Coré perez",
            "requestHours": 5,
            "requestDate": "2025-12-24T15:44:56"
        }
    ]
};

const responseUpdateStartZenStatus = {
    payload: {
        code: 200,
        message: "Se actualizó el estado"
    },
};
  

const responseListStarZenStatus = {
    "payload": [
        {
            "value": 1,
            "label": "Aprobar"
        },
        {
            "value": 2,
            "label": "Rechazar"
        }
    ]
};

  

export const service = {
    
    getTypeDocumentStarAssignment: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseTypeDocumentStarAssignment }), 1000);
    }),

    getTypeStar: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseTypeStar }), 1000);
    }),

    getCategoryStarAssignment: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCategoryStarAssignment }), 1000);
    }),

    postStarAssignmentAll: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCreate}), 1000);
    }),

    postStarAssignmentInd: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCreate}), 1000);
    }),

    getCardsList: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCads }), 1000);
    }),

    getAllTemplates: () => new Promise(resolve => {
        setTimeout(resolve({ data:  listTemplate}), 1000);
    }),

    scatterStarsTemplates: () => new Promise(resolve => {
        setTimeout(resolve({ data:  scatterStarsTemplates}), 1000);
    }),

    downloadTemplate: () => new Promise(resolve => {
        setTimeout(resolve({ data:  downloadTemplate}), 1000);
    }),

    getTypeStarList: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseTypeStarList }), 1000);
    }),

    postRequestsZen: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCreate}), 1000);
    }),

    getListRequestsZen: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseListRequestsZen }), 1000);
    }),

    getListStarZenStatus: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseListStarZenStatus }), 1000);
    }),

    postStarZenStatus: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseUpdateStartZenStatus}), 1000);
    }),

}
